import { render, staticRenderFns } from "./StoreStandardStockManagement.vue?vue&type=template&id=6ab644e8&"
import script from "./StoreStandardStockManagement.vue?vue&type=script&lang=js&"
export * from "./StoreStandardStockManagement.vue?vue&type=script&lang=js&"
import style0 from "./StoreStandardStockManagement.vue?vue&type=style&index=0&id=6ab644e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports